export default __webpack_public_path__ + "static/media/First Bishops of CSI.ec24fdcf.jpg";